const ShareMessageLang = {
  messages: {
    'en': {
      'dear': 'Dear',
      'account_update': 'here is your account update from Moxpal Khata.',
      'total_due': 'Total Balance Due',
      'view_full_account': 'View full account Statement',
      'app_name': 'Moxpal Khata',
      'credit': 'Credit',
      'debit': 'Debit',
    },
    'hi': {
      'dear': 'प्रिय',
      'account_update': 'आपके खाते की जानकारी अपडेट की गई है',
      'total_due': 'कुल बकाया राशि',
      'view_full_account': 'पूरा खाता विवरण यहां देखें ',
      'app_name': 'मोक्षपाल खाता',
      'credit': 'क्रेडिट',
      'debit': 'डेबिट',
    },
    'en_in': {
      'dear': 'Dear',
      'account_update': 'yahan aapka account update hai Moxpal Khata se.',
      'total_due': 'Total Balance Due',
      'view_full_account': 'Poora account statement dekhein',
      'app_name': 'Moxpal Khata',
      'credit': 'Credit',
      'debit': 'Debit',
    },
    'gu': {
      'dear': 'પ્રિય',
      'account_update': 'તમારા ખાતાની માહિતી અપડેટ કરવામાં આવી છે',
      'total_due': 'કુલ બાકી રકમ',
      'view_full_account': 'પૂર્ણ ખાતાની વિગતો અહીં જુઓ',
      'app_name': 'મોક્શપાલ ખાતા',
      'credit': 'ક્રેડિટ',
      'debit': 'ડેબિટ',
    },
    'mr': {
      'dear': 'प्रिय',
      'account_update': 'तुमच्या खात्याची माहिती अपडेट करण्यात आली आहे',
      'total_due': 'एकूण बाकी रक्कम',
      'view_full_account': 'पूर्ण खात्याचा तपशील येथे पहा',
      'app_name': 'मोक्षपाल खाता',
      'credit': 'क्रेडिट',
      'debit': 'डेबिट',
    },
    'pa': {
      'dear': 'ਪਿਆਰੇ',
      'account_update': 'ਤੁਹਾਡੇ ਖਾਤੇ ਦੀ ਜਾਣਕਾਰੀ ਅੱਪਡੇਟ ਕੀਤੀ ਗਈ ਹੈ',
      'total_due': 'ਕੁੱਲ ਬਾਕੀ ਰਕਮ',
      'view_full_account': 'ਪੂਰਾ ਖਾਤਾ ਵੇਰਵਾ ਇੱਥੇ ਵੇਖੋ',
      'app_name': 'ਮੋਕਸ਼ਪਾਲ ਖਾਤਾ',
      'credit': 'ਕ੍ਰੈਡਿਟ',
      'debit': 'ਡੈਬਿਟ',
    },
    'ta': {
      'dear': 'அன்புள்ள',
      'account_update': 'உங்கள் கணக்கு தகவல் புதுப்பிக்கப்பட்டுள்ளது',
      'total_due': 'மொத்த நிலுவை தொகை',
      'view_full_account': 'முழு கணக்கு விவரத்தை இங்கே பார்க்கவும்',
      'app_name': 'மோக்ஷ்பால் காத்தா',
      'credit': 'கிரெடிட்',
      'debit': 'டெபிட்',
    },
    'te': {
      'dear': 'ప్రియమైన',
      'account_update': 'మీ ఖాతా సమాచారం నవీకరించబడింది',
      'total_due': 'మొత్తం బాకీ మొత్తం',
      'view_full_account': 'పూర్తి ఖాతా వివరాలను ఇక్కడ చూడండి',
      'app_name': 'మోక్షపాల్ ఖాతా',
      'credit': 'క్రెడిట్',
      'debit': 'డెబిట్',
    },
  },

  t: function (lang, key) {
    const l = lang || 'en';
    return this.messages[l]?.[key] || this.messages['en']?.[key] || key;
  }
};

export default ShareMessageLang;
